/**!SECTION
 * Este codigo filtra los elementos en pantalla segun sea el tipo o calidad
 */
$(function (e) {
  jQuery(document).on("change", ".checklist-filter-types", function (e) {
    let id = jQuery(this).val();
    let context = jQuery(this).closest(".table-checklist");

    jQuery(".checklist-element ", context).removeClass(
      "checklist-element-hidden"
    );
    jQuery(".checklist-element ", context).removeClass(
      "checklist-element-show"
    );
    if (id > 0) {
      jQuery(
        '.checklist-element:not([data-types="' + id + '"]) ',
        context
      ).addClass("checklist-element-hidden");
      jQuery('.checklist-element[data-types="' + id + '"]', context).addClass(
        "checklist-element-show"
      );
    }
    _updateURLOptions();
    jQuery(".checklist-filter-qualities", context).val(-1).trigger("change");
  });

  jQuery(document).on("change", ".checklist-filter-qualities", function (e) {
    let id = jQuery(this).val();
    let context = jQuery(this).closest(".table-checklist");

    jQuery(".checklist-element ", context).removeClass(
      "checklist-element-Q-hidden"
    );
    jQuery(".checklist-element ", context).removeClass(
      "checklist-element-Q-show"
    );
    if (id > 0) {
      jQuery(
        '.checklist-element:not([data-qualities="' + id + '"]) ',
        context
      ).addClass("checklist-element-Q-hidden");
      jQuery(
        '.checklist-element[data-qualities="' + id + '"]',
        context
      ).addClass("checklist-element-Q-show");
    }

    _updateURLOptions();
  });
});
